var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCubeMapIcon = function SvgCubeMapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#F46200",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m32 4 22 10-22 10-22-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F46200",
    stroke: "#F46200",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M10 14v26l22 12V24zM54 14v26L32 52V24z"
  })));
};
export default SvgCubeMapIcon;